module.exports = __webpack_public_path__ + "static/media/LogoBusinessReportsTrans.f4cf9baa.png";